import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"
import "../styles/global.css"
import "../styles/ConfirmationScreen.css"
import { useModal } from "../context/modalContext"
import { useApp } from "../context/appContext"
import Modal from "./shared/Modal"
import { patchCancelAppointment } from "../services/patchCancelAppointment"
import { patchConfirmAppointment } from "../services/patchConfirmAppointment"
import AddToCalendar from "./AddToCalendar"
import { formatCustomerName, formatDateLong, formatLocation, formatPhoneNumber, formatTestType } from "../utils/lib"
import { useSearchParams } from 'react-router-dom'; // To read query params
import { fbApiUrl } from "./shared/facebooktrack_config";  


const ConfirmationScreen = () => {

  const [bookingConfirmed, setBookingConfirmed] = useState(true)
  const [searchParams, setSearchParams] = useSearchParams(); // Hook to get query params
  const { openModal, isModalOpen, closeModal, modalType, setLoading } = useModal()
  const { form, setForm, setCurrentPage, currentPage } = useApp()
  console.log("Current Page", currentPage);

  const confirmModalAction = async () => {
    setLoading(true)
    if(modalType === 'cancel') {
      const cancelRes = await patchCancelAppointment(form?.appointmentId, form?.bookingForm?.personEmail)
      setLoading(false)
      if(cancelRes?.status === "Cancelled") {
        setBookingConfirmed(false)
        setCurrentPage("map")
        setForm({
          location: null,
          date: null,
          time: null,
          testId: null,
          staffId: "any",
          appointmentId: null,
          clientId: null,
          bookingForm: {
            salutation: "Mr",
            firstName: "",
            lastName: "",
            personMobilePhone: "",
            personEmail: "",
            Diabetes__pc: "No",
            First_Appointment__c: false,
            Dont_Confirm__c: false,
            Communication_Preferences__c: false,
            Marketing_Opt_In__c: false
          }
      })
        toast.success("Appointment cancelled successfully!")
      } else {
        toast.error('Failed to cancel appointment')
      }
    }
    // else {
    //   const confirmRes = await patchConfirmAppointment(form?.appointmentId, form?.clientId)
    //   setLoading(false)
    //   if(confirmRes?.status === "Confirmed") {
    //     setBookingConfirmed(true)
    //     toast.success("Appointment confirmed successfully!")
    //   } else {
    //     toast.error('Failed to confirm appointment')
    //   }
    // }
    closeModal()
  }

  const changeAppointment = async() => {
    const cancelRes = await patchCancelAppointment(form?.appointmentId)
    setLoading(false)
    if(cancelRes?.status === "Cancelled") {
      setBookingConfirmed(false)
      setForm((prevForm) => ({
        ...prevForm, // Retain existing properties
        staffId: "any",
        appointmentId: null,
        clientId: null,
        bookingForm: {
          ...prevForm.bookingForm, // Retain existing values in bookingForm
        },
      }));
      setCurrentPage("date-picker")
      toast.success("Appointment cancelled successfully!")
    } else {
      toast.error('Failed to cancel appointment')
    }
  }
  /**
   * Confirm booking as soon as the page loads
   */
useEffect(() => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100); // Adjust delay if needed
}, []);


  useEffect(() => {
    const confirmBooking = async () => {
      /*if (form?.appointmentId && form?.clientId && form?.bookingForm?.personEmail) {
        setLoading(true);
        const confirmRes = await patchConfirmAppointment(form?.appointmentId, form?.clientId, form?.bookingForm?.personEmail);
        setLoading(false);
        if (confirmRes?.status === "Confirmed") {
          setBookingConfirmed(true);
          toast.success("Appointment confirmed successfully!");
        } else {
          toast.error("Failed to confirm appointment");
        }
      }*/
      setBookingConfirmed(true); //
    };
    //if (form?.bookingForm?.Dont_Confirm__c !== true) {
      confirmBooking();
    //}


  }, [form?.appointmentId, form?.clientId, form?.bookingForm?.personEmail, setCurrentPage, setLoading]);


  useEffect(() => {
 
    const sendDataToFacebookAPI_Confirmation = async () => {
      if (!fbApiUrl) {
        console.error("Error: fbApiUrl is not defined!");
      } 
      else {
        try{
      
          const ipResponse = await fetch("https://api64.ipify.org?format=json");
          const ipData = await ipResponse.json();
          const clientIp = ipData.ip; // Extracted IP Address

          // Get User Agent
          const userAgent = navigator.userAgent;


          const data = {
            data: [
              {
                event_name: "Confirm Booking",
                event_time: Math.floor(Date.now() / 1000),
                user_data: {
                  client_ip_address: clientIp,
                  client_user_agent: userAgent,
                },
                action_source: "website",
                custom_data: {
                  client_id: form?.clientId,
                  salutation: form?.bookingForm?.salutation,
                  firstName: form?.bookingForm?.firstName,
                  lastName: form?.bookingForm?.lastName,
                  email: form?.bookingForm?.personEmail,
                  phone: form?.bookingForm?.personMobilePhone,
                  other_phone: form?.bookingForm?.personHomePhone,
                  diabetes: form?.bookingForm?.Diabetes__pc,
                  first_appointment: form?.bookingForm?.First_Appointment__c,
                  marketing_opt_in: form?.bookingForm?.Marketing_Opt_In__c,
                  dont_confirm: form?.bookingForm?.Dont_Confirm__c,
                  communication_preferences: form?.bookingForm?.Communication_Preferences__c,
                },
              },
            ],
            test_event_code: "TEST58912",
          };
        
          const response = await fetch(fbApiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });
      
          const result = await response.json();
        }
        catch (error) {
          console.error("Error sending data to Facebook API:", error);
        }
      }
    }

    sendDataToFacebookAPI_Confirmation();

  }, [form?.clientId, form?.bookingForm?.personEmail]);



  // Redirect if either clientId or location is missing
  useEffect(() => {
    if (!form?.clientId || !form?.location) setCurrentPage("map")
  }, [form?.clientId, form?.location, setCurrentPage])


  useEffect(() => {
    if (form?.location?.Id && form?.location?.Name) {
      
      if (!window.dataLayer || !Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
      }
      
      let booking_source = "Booking App";
      const locationId = searchParams.get('locationId');
      if(locationId){
        booking_source = form.location.Name;
      }

      window.dataLayer.push({
        event: "store_booking",
        store_id: form.location.Id,
        store_name: form.location.Name,
        event_category: "Bookings",
        event_label: "Store Booking",
        booking_source: booking_source,
        value: 1,
      });
      
      console.log("Updated dataLayer:", window.dataLayer);
    } else {
      console.warn("form location details are missing.");
    }
  }, [form?.location]); 
  
  useEffect(() => {
    console.log("Updated Diabetes__pc:", form?.bookingForm?.Diabetes__pc);
  }, [form?.bookingForm?.Diabetes__pc]);
  
  // Conditional rendering to avoid null errors
 // if (!form || !form?.clientId || !form?.location) return null

  return (
    <>
      <div className="main">
         {/* Conditionally render based on Diabetes__pc */}        
         {form?.bookingForm?.Diabetes__pc === 'Yes' ? (
      <div className="page-text">
        <h1 className="page-heading">Booking Requested</h1>
        <p className="page-description">A team member will be in touch soon to confirm your appointment.</p>
      </div>
    ) : form?.bookingForm?.Diabetes__pc === 'No' ? (
      <div className="page-text">
        <h1 className="page-heading">Booking Confirmed</h1>
        <p className="page-description">Your appointment has been booked.</p>
      </div>
    ) : null}

        <div className="content">
          <div className="appointment-time">
            <div className="appointment-time-details">
              <p className="appointment-time-heading">Appointment Time and Date</p>
              <h2 className="appointment-time-slot">{form?.time?.startTimeReadable} - {formatDateLong(form?.time?.appointmentDate)}</h2>
            </div>
          </div>

          <hr className="divider" />

          <div className="appointment-details-confirm">
            <div className="detail-section">
              <h3 className="detail-heading">Store Location</h3>
              <p className="detail-pargraph">{formatLocation(form?.location)}</p>
            </div>

            <div className="detail-section">
              <h3 className="detail-heading">Appointment Type</h3>
              <p className="detail-pargraph">{formatTestType(form?.testId)}</p>
            </div>

            <div className="detail-section">
              <h3 className="detail-heading">Preferred Optometrist</h3>
              <p className="detail-pargraph">{form?.staffName}</p>
            </div>

            <div className="detail-section">
              <h3 className="detail-heading">Appointment for</h3>
              <p className="detail-pargraph">{formatCustomerName(form?.bookingForm)}</p>
              <p className="detail-pargraph">{form?.bookingForm?.personEmail}</p>
              <p className="detail-pargraph">{formatPhoneNumber(form?.bookingForm.personMobilePhone)}</p>
            </div>
          </div>

          <hr className="divider" />

          <div className="manage-booking">
            <h3 className="detail-heading">Manage your booking</h3>
            <div className="action-btns confirm-action-btns">
              {/*<button className="calendar-btn full-btn" type="button" onClick={() => openModal("confirm")}>*/}
              {/*  Confirm Appointment*/}
              {/*</button>*/}
              <button className="calendar-btn full-btn make-another-appointment" type="button"
                      onClick={() => {
                          window.location.reload('/booking-app');
                      }}
              >
                Make another Appointment
              </button>
              <AddToCalendar bookingConfirmed={bookingConfirmed}/>
              {/*<button className="calendar-btn full-btn" type="button" onClick={confirmModalAction}>*/}
              {/*  Confirm Appointment*/}
              {/*</button>*/}
              <button className="calendar-btn full-btn change-appointment" type="button" onClick={changeAppointment}
                      disabled={!bookingConfirmed}>
                Change Appointment
              </button>
              <button className="calendar-btn full-btn cancel-appointment" type="button" onClick={() => openModal("cancel")}
                      disabled={!bookingConfirmed}>
                Cancel Appointment
              </button>

            </div>
          </div>
          {/*<div className="book-appointment">*/}
          {/*    <div className="d-flex btn-container">*/}
          {/*    <button className="change-store" onClick={() => setCurrentPage("map")}>Make Another Appointment</button>*/}
          {/*    </div>*/}
          {/*</div>*/}
        </div>
      </div>
      <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          onConfirm={confirmModalAction}
          type={modalType}
      />
    </>
  )
}


export default ConfirmationScreen